const firebase = require('firebase/app')
require('firebase/firestore')
require('firebase/auth')
require('firebase/storage')
import firebaseConfig from './firebaseConfig'
firebase.initializeApp(firebaseConfig)
export default firebase



// WEBPACK FOOTER //
// ./src/Firebase/FirebaseInit.js